import { Tooltip, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import React from 'react';
import Dashboard from 'types/entities/Dashboard';

const ProjectNameCell = React.memo((row: Dashboard) => (
  <span>
    {row?.project_name && (
      <Tooltip title={row?.project_name}>
        <Typography variant="body2" noWrap>
          {row?.project_name}
        </Typography>
      </Tooltip>
    )}
  </span>
));

export default ProjectNameCell;
